import { createI18n } from 'vue-i18n'
import he from './locales/he.json'
import en from './locales/en.json'
import ar from './locales/ar.json'

// Supported languages. `dir` drives the document direction (he/ar = RTL, en = LTR).
export const SUPPORTED_LOCALES = [
  { code: 'he', name: 'עברית', dir: 'rtl' },
  { code: 'en', name: 'English', dir: 'ltr' },
  { code: 'ar', name: 'العربية', dir: 'rtl' },
]

const STORAGE_KEY = 'hegati_locale'
const DEFAULT_LOCALE = 'he'

function readSavedLocale() {
  try {
    const saved = localStorage.getItem(STORAGE_KEY)
    if (saved && SUPPORTED_LOCALES.some((l) => l.code === saved)) return saved
  } catch (e) {
    /* localStorage unavailable (private mode) — fall back to default */
  }
  return DEFAULT_LOCALE
}

const i18n = createI18n({
  legacy: false, // Composition API mode; globalInjection keeps $t working in Options API components
  globalInjection: true,
  locale: readSavedLocale(),
  fallbackLocale: DEFAULT_LOCALE,
  messages: { he, en, ar },
})

// Apply <html lang/dir> for a given locale. Safe to call before mount.
export function applyDocumentDir(locale) {
  const meta = SUPPORTED_LOCALES.find((l) => l.code === locale) || SUPPORTED_LOCALES[0]
  const el = document.documentElement
  el.setAttribute('lang', meta.code)
  el.setAttribute('dir', meta.dir)
}

// היקף ה-i18n הוא ממשק הגן ומנהל האשכול בלבד (docs/features/i18n.md). שאר האזורים —
// Backoffice, נחיתה, לידים והעמודים המשפטיים — הם עברית קשיחה.
export function isLocalizedPath(path) {
  return /^\/(kindergarten|manager)(\/|$)/.test(path || '')
}

// קובע <html lang/dir> לפי המסלול: באזורי ה-i18n לפי השפה הנבחרת, ובכל השאר he/rtl.
// בלי זה, בחירת ערבית/אנגלית בממשק הגן "דולפת" לכל האתר: ה-Backoffice מסומן lang="ar"
// אף שתוכנו עברית (הדפדפן מציע לתרגם ומעוות את הטקסט), ובאנגלית גם מתהפך ל-LTR.
export function applyDocumentDirForPath(path) {
  applyDocumentDir(isLocalizedPath(path) ? currentLocale() : DEFAULT_LOCALE)
}

// Switch language: updates i18n, persists the choice, and flips document direction.
export function setLocale(locale) {
  if (!SUPPORTED_LOCALES.some((l) => l.code === locale)) return
  i18n.global.locale.value = locale
  try {
    localStorage.setItem(STORAGE_KEY, locale)
  } catch (e) {
    /* ignore persistence failure */
  }
  applyDocumentDir(locale)
}

export function currentLocale() {
  return i18n.global.locale.value
}

export default i18n
